// import { ImArrowRight2 } from 'react-icons/im';

export const buttonTheme = {
  baseStyle: {
    color: 'white',
    borderRadius: '30px',
    // HACK: bg only works if we use bg & bgColor in that explicit order!
    // https://github.com/chakra-ui/chakra-ui/issues/3293
    bg: 'primaryColor',
    // bgColor: 'primaryColor',
    padding: '25px 50px 23px 50px !important',

    minWidth: '250px !important',
    _hover: {
      bgColor: 'primaryColor_hover',
      _disabled: {
        bg: 'reno.grey400',
      },
    },
    _active: {
      // bg: 'red',
      // bgColor: 'primaryColor',
      // transform: 'scale(0.98)',
      color: 'white',
      bg: 'primaryColor_hover',
      borderColor: 'primaryColor_hover',
    },
  },
  variants: {
    radio: {
      bg: 'white',
      color: 'black',
      padding: '25px 20px 23px 20px !important',
      _hover: {
        color: 'white',
        bg: 'primaryColor_hover',
        transform: 'scale(0.98)',
        borderColor: 'primaryColor_active',
      },
      _active: {
        color: 'white',
        bg: 'primaryColor_active',
        transform: 'scale(0.98)',
        borderColor: 'primaryColor_active',
      },
    },

    inlineText: {
      bg: 'none',
      color: 'primaryColor',
      margin: '0px',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      fontWeight: 'normal',
      padding: '0px 0px !important',
      display: 'inline',
      textDecoration: 'underline',
      _hover: {
        textDecoration: 'none',
        bg: 'none',
        color: 'primaryColor',
        padding: '0px 0px',
      },
      _active: {
        padding: '0px 0px',
        textDecoration: 'none',
        bg: 'none',
        color: 'primaryColor',
      },
    },

    icon: {
      bg: 'none',
      color: 'primaryColor',
      margin: '0px',
      fontSize: 'inherit',
      padding: '0px 0px !important',
      _hover: {
        bg: 'none',
        color: 'primaryColor',
        padding: '0px 0px',
      },
      _active: {
        padding: '0px 0px',
        bg: 'none',
        color: 'primaryColor',
      },
    },

    summary: {
      bg: 'primaryColor',
      color: 'white',
      borderRadius: '15px',
      fontSize: '80%',
      height: 'auto',
      padding: '5px 10px 5px 10px !important',
      _active: {
        bg: '#2477b3',
        transform: 'scale(0.98)',
        borderColor: '#2477b3',
      },
    },

    summary_rossel: {
      bg: 'rossel.blue',
      color: 'white',
      // borderRadius: '15px',
      // fontSize: '80%',
      // height: 'auto',
      // padding: '5px 10px 5px 10px !important',
      // _active: {
      //   bg: '#2477b3',
      //   transform: 'scale(0.98)',
      //   borderColor: '#2477b3',
      // },
      _hover: {
        bg: 'rossel.blue_hover',
        color: 'white',
      },
    },

    'radio-selected': {
      bg: 'white',
      color: 'selectionColor',
      border: '2px solid',
      borderColor: 'selectionColor',
      padding: '25px 20px 23px 20px !important',
      _hover: {
        bg: 'selectionColor',
        color: 'white',
      },
      _active: {
        bg: '#2477b3',
        transform: 'scale(0.98)',
        borderColor: '#2477b3',
      },
    },

    multilineWithArrow: {
      whiteSpace: 'wrap',
      fontSize: 'sm',
      padding: 0,
      paddingY: '2em',
      paddingX: '2em',
      paddingLeft: '3em',
      width: '100%',

      gap: '10px',

      fontWeight: 'bold',
      textAlign: 'left',
      // transition: 'all 0.3s',
    },
  },
};
